import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["user"];
import "core-js/modules/es.function.name.js";
import React from 'react';
import { TooltipPill } from 'components/Pill';
import getFullUserName from 'utils/getFullUserName';
export default function UserPill(_ref) {
  var user = _ref.user,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var displayName = getFullUserName(user) || user.name; // `name` is the email

  return /*#__PURE__*/React.createElement(TooltipPill, _extends({}, otherProps, {
    icon: "user",
    iconColor: "user"
  }), displayName);
}